module.exports = __webpack_public_path__ + "img/H000010_sprout.4826b2da.png";